module.exports = __webpack_public_path__ + "static/media/LogoBlanco.b1ab79c1.svg";